import React, { useState } from "react";
import Table from "./Table";
import { Toolbar } from "primereact/toolbar";
// import { Accordion, AccordionTab } from "primereact/accordion";
// import { Filter } from "./Filter";

interface IProps {
  filter: any,
  groupName: string | null,
}

const CreatedTimesheetsReport = (props: IProps) => {
  // const [filter, setFilter] = useState<any>();
  // const [groupName, setGroupName] = useState<string | null>(null);

  return (
    <>
      <Toolbar className="mb-1 py-0" />
      {/* <Accordion>
        <AccordionTab header="Filter">
          <Filter filter={filter} setFilter={setFilter} setGroupName={setGroupName} />
        </AccordionTab>
      </Accordion> */}
      <Table filter={props.filter} groupName={props.groupName} />;
    </>
  );
};

export default CreatedTimesheetsReport;
